document.addEventListener('DOMContentLoaded', () => {
    // Map CSS property → class prefix
    const propToClass = {
        'padding-top': 'u-pt',
        'padding-right': 'u-pr',
        'padding-bottom': 'u-pb',
        'padding-left': 'u-pl',
    };

    // Regex to extract the spacing slug from var(--wp--preset--spacing--<slug>)
    const varRe = /var\(\s*--wp--preset--spacing--([a-z0-9\-]+)\s*\)/i;

    function applyPaddingClasses(root = document) {
        const nodes = root.querySelectorAll('[style*="--wp--preset--spacing--"]');
        nodes.forEach((el) => {
            const styleAttr = el.getAttribute('style');
            if (!styleAttr) return;

            Object.entries(propToClass).forEach(([cssProp, clsPrefix]) => {
                // Find "padding-*: var(--wp--preset--spacing--slug)"
                const propRe = new RegExp(`${cssProp}\\s*:\\s*([^;]+)`, 'i');
                const match = styleAttr.match(propRe);
                if (!match) return;

                const value = match[1].trim();
                const varMatch = value.match(varRe);
                if (!varMatch) return;

                const slug = varMatch[1]; // e.g., space-0f or space-0-d (depends on your theme.json)
                // Build class and apply
                const cls = `${clsPrefix}-${slug}`;
                el.classList.add(cls);
            });
        });
    }

    applyPaddingClasses();

    // Optional: handle dynamically inserted nodes (e.g. in the editor or AJAX)
    const mo = new MutationObserver((mutations) => {
        for (const m of mutations) {
            m.addedNodes.forEach((n) => {
                if (n.nodeType === 1) applyPaddingClasses(n);
            });
            if (m.type === 'attributes' && m.attributeName === 'style' && m.target) {
                applyPaddingClasses(m.target.parentNode || document);
            }
        }
    });
    mo.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['style'],
    });
});